import styled from 'styled-components'

export const FooterPage = styled.footer`
padding: 20px;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
background-color: #252525;
color: white;
h6{
    font-size: 25px;
    font-weight: 700;
    margin-bottom: 10px;
}
>p{
    font-size: 12px;
    color: white;
    margin-bottom: 10px;
    text-align:center ;
}
`;

export const FooterLink = styled.div`
display: flex;
flex-wrap: wrap;
justify-content: center;
>a{
    padding: 10px 16px;
    font-size: 13px;
    font-weight: 700;
    background-color: black;
    margin: 0px 5px;
    border-radius: 21px;
    margin-bottom: 10px;
    }
`;

export const FooterIcons = styled.div`
display: flex;
flex-wrap: wrap;
justify-content: center;
span {
    padding: 0px 18px;
    background-color: white;
    margin: 0px 4px;
    color: black;
    border-radius: 20px;
    margin-top: 10px;
    cursor: pointer;
    :hover{
        background-color: var(--primaryColor);
        color: white;
    }
    i{
        font-size: 14px;
    }
}

`;
